<template>
  <div style="width: 100%" class="fill-height">
    <v-container>
      <v-row style="margin-top: 40px" class="d-flex justify-center">
        <v-col cols="4" class="justify-center" :class="['px-0']">
          <v-card>
            <v-card-title
              class="d-flex"
              style="
                vertical-align: middle;
                background-color: #1577da;
                height: 58px;
                color: white;
              "
            >
              <span class="text-h5" style="font-weight: bold"
                >Isključivanje firme</span
              >
            </v-card-title>
            <v-card-text>
              <v-row class="pt-5 pr-4 pl-3">
                <div style="width: 65%" class="pr-0 pl-0" cols="8">
                  <v-autocomplete
                    class="pb-1"
                    outlined
                    clearable
                    dense
                    label="Odaberite firmu"
                    :items="companies"
                    item-text="name"
                    item-value="id"
                    return-object
                    hide-details
                    v-model="selectedCompany"
                  ></v-autocomplete>
                </div>
                <div style="width: 35%" class="pr-0 pl-2" cols="4">
                  <v-text-field
                    label="Razlog blokiranja"
                    outlined
                    dense
                    hide-details
                    v-model="reason"
                  ></v-text-field>
                </div>
              </v-row>
            </v-card-text>
            <v-card-actions class="d-flex pt-0 mt-0 pr-4 justify-end">
              <v-btn
                class="btn dangerButton"
                @click="changeState('deactivate')"
              >
                Deaktiviraj korisnike
              </v-btn>
              <v-btn
                id="success"
                class="btn successButton"
                @click="changeState('activate')"
              >
                Aktiviraj korisnike
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center">
        <v-col cols="8" class="justify-center" :class="['px-0']">
          <v-card v-for="(company, i) in deactivatedCompanies" :key="i" hover>
            <v-row
              class="ma-0"
              :class="['ma-0', 'status-failed-exp']"
              style="height: 48px !important"
            >
              <div class="pl-3" style="width: 50%" :class="[densityPadding]">
                <div class="pl-1 caption grey--text" style="text-align: left">
                  Naziv
                </div>
                <div class="pl-1 text-capitalize" style="text-align: left">
                  {{ company.name }}
                </div>
              </div>
              <div style="width: 50%" :class="[densityPadding]">
                <div class="pl-1 caption grey--text" style="text-align: center">
                  Razlog
                </div>
                <div class="pl-1" style="text-align: center">
                  {{ company.reason }}
                </div>
              </div>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
// import state from '@/state'
import { df, functions } from '@/plugins/firebase'
// import { clone } from '@/plugins/utils'
import applicationSettings from '@/mixins/applicationSettings'

export default {
  name: 'CompanySettings',
  mixins: [applicationSettings],
  inject: ['showLoader', 'hideLoader', 'showMsgBox'],
  components: { },
  data: () => ({
    companies: [],
    selectedCompany: undefined,
    deactivatedCompanies: [],
    reason: '',
    listeners: []
  }),
  computed: {
  },
  watch: {
  },
  mounted () {
    this.getDeactivatedCompanies()
    this.getCompanies()
  },
  beforeDestroy () {
  },
  methods: {
    getDeactivatedCompanies () {
      this.deactivatedCompanies = []
      df.collection('companies')
        .where('deactivated', '==', true)

        .onSnapshot((doc) => {
          this.deactivatedCompanies = []
          doc.docs.forEach((rec) => {
            this.deactivatedCompanies.push(rec.data())
          })

          this.deactivatedCompanies = this.deactivatedCompanies.sort((a, b) => a.name.localeCompare(b.name))

          if (doc.docs.length === 0) {
            this.deactivatedCompanies = []
          }

          console.log('deactivatedCompanies', this.deactivatedCompanies)
        })
    },
    getCompanies () {
      this.companies = []
      const query = df.collection('companies')
        .orderBy('name', 'asc')

      const listener = query
        .onSnapshot((doc) => {
          this.companies = []
          doc.docs.forEach((rec) => {
            this.companies.push(rec.data())
          })

          this.companies = this.companies.sort((a, b) => a.name.localeCompare(b.name))

          if (doc.docs.length === 0) {
            this.companies = []
          }
        }
        )

      this.listeners.push(listener)
    },
    changeState (action) {
      this.showLoader()
      var userApi = functions.httpsCallable('userapi')

      var params = {
        company_id: this.selectedCompany.id,
        action: action
      }

      if (this.reason && this.reason !== '') {
        params.reason = this.reason
      }

      userApi({
        action: {
          operation: 'set',
          entity: 'unpaid',
          params: params
        }
      })
        .then(async (result) => {
          this.hideLoader()
          if (result.data.code === 200) {
            this.showMsgBox({
              text: 'Uspješna izmjena!',
              actions: ['cancel'],
              cancelBtnText: this.$t('$vuetify.close'),
              color: 'error'
            })
          } else {
            this.showMsgBox({
              text: 'Greška prilikom spremanja podataka.',
              actions: ['cancel'],
              cancelBtnText: 'OK',
              color: 'error'
            })
          }
        })
    }
  }

}
</script>
<style scoped>
</style>
